// @flow
import React, { useState } from 'react';
import { Card, Icon, Text, Row, Col } from '../.';
import AccordionIconWrapper from './AccordionIconWrapper';
import AccordionWrapper from './AccordionWrapper';

type Props = {
  show?: Boolean,
  title: String,
  children: Element,
  hasShadow: Boolean,
  iconName?: String,
  hasRadius?: Boolean,
  iconChildren?: Boolean,
  className?: String,
};

Accordion.defaultProps = {
  hasShadow: false,
  hasRadius: true,
  iconChildren: false,
};

export default function Accordion(props: Props) {
  const [show, setShow] = useState(props.show);

  const toggle = () => setShow(!show);

  const {
    children,
    title,
    hasShadow,
    iconName,
    hasRadius,
    iconChildren,
    className,
  } = props;

  return (
    <Card hasShadow={hasShadow} type="whiteBackground" hasRadius={hasRadius}>
      <Row>
        <Col
          xs={1}
          className={`p-0 d-flex align-items-center justify-content-center ${className}`}
        >
          {iconName ? (
            iconChildren ? (
              <Icon
                color={show ? 'primary' : 'blackText'}
                size={24}
                name={iconName}
              >
                {iconChildren}
              </Icon>
            ) : (
              <Icon
                color={show ? 'primary' : 'blackText'}
                size={24}
                name={iconName}
              />
            )
          ) : null}
        </Col>
        <Col xs={11}>
          <div
            className="d-flex pointer justify-content-between py-3"
            onClick={toggle}
          >
            <Text
              color={show ? 'primary' : 'black'}
              className="px-2 m-0 user-select-none"
              size="plg"
              animation
            >
              {title}
            </Text>
            <AccordionIconWrapper show={show}>
              <Icon
                color={show ? 'primary' : 'gray'}
                name="arrows-up"
                useDirection
              />
            </AccordionIconWrapper>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={1} />
        <Col xs={11}>
          <AccordionWrapper show={show}>
            {show ? children : null}
          </AccordionWrapper>
        </Col>
      </Row>
    </Card>
  );
}
